import React from "react";
import { observable, action, makeObservable } from "mobx";
import { FormFieldModel } from "../../formField/FormField_model";
import { FormFieldType } from "../../formField/FormFieldTypes";
import { InputProps } from "../../../../components/ui/_forms/Input";
import { INIT_GOOGLE_TEXT_FIELD } from "./GoogleInput_init";
import { IGoogleFieldModel } from "./IGoogleInputFieldModel";
import { PlacesAutocompleteInputBox } from "../../../../components/widgets/PlacesAutocompleteInputBox/PlacesAutocompleteInputBox";

export class GoogleFieldModel extends FormFieldModel<string, InputProps> implements IGoogleFieldModel {
  @observable value: string = "";
  @observable placeData?: google.maps.places.PlaceResult;

  placeholder: string = "";
  readonly type: FormFieldType = FormFieldType.GoogleInput;
  inputType: "text" | "password" | "file" | "textarea" | "hidden";
  borderStyle: "underline" = null;
  autoFocus: boolean = false;
  onKeyUp: (e: React.KeyboardEvent<any>) => void;
  onBlur: (e) => void;

  constructor(initOpts?: IGoogleFieldModel) {
    super(initOpts);
    makeObservable(this);

    if (initOpts) {
      this.value = initOpts.value || "";
      this.validate = initOpts.validate || INIT_GOOGLE_TEXT_FIELD.validate;
      this.placeholder = initOpts.placeholder || INIT_GOOGLE_TEXT_FIELD.placeholder;
      this.inputType = initOpts.inputType || INIT_GOOGLE_TEXT_FIELD.inputType;
      this.borderStyle = initOpts.borderStyle || this.borderStyle;
      this.extractValue = initOpts.extractValue || this.extractValue;
      this.autoFocus = initOpts.autoFocus || INIT_GOOGLE_TEXT_FIELD.autoFocus;
      this.onKeyUp = initOpts.onKeyUp || this.onKeyUp;
      this.onBlur = initOpts.onBlur || this.onBlur;
    }
  }

  @action.bound
  setValue(val: string): void {
    this.hasChanges = true;
    this.value = val;
    if (this.validateOnChange && this.validate) {
      this.validate(this.value);
    }
  }

  @action.bound
  setPlaceData(place: google.maps.places.PlaceResult): void {
    this.placeData = place;
    const address = place?.formatted_address || "";
    this.setValue(address);
  }

  extractValue() {
    return this.value.trim ? this.value.trim() : this.value;
  }

  @action.bound
  setFieldValue(val: string): void {
    this.hasChanges = false;
    this.value = val;
  }

  validate: (...args: any[]) => any;

  @action.bound
  reset(): void {
    this.hasChanges = true;
    this.errorMessage = null;
    this.value = this.defaultValue || "";
    this.placeData = undefined;
  }

  renderComponent = () => {
    return <Placeholder setPlaceData={this.setPlaceData} placeholder={this.placeholder} autoFocus={this.autoFocus} />;
  };
}

const Placeholder: React.FC<{
  setPlaceData: (place: google.maps.places.PlaceResult) => void;
  placeholder: string;
  autoFocus: boolean;
}> = ({ setPlaceData, placeholder, autoFocus }) => {
  return (
    <PlacesAutocompleteInputBox
      onPlaceSelect={place => {
        setPlaceData(place);
      }}
      placeholder={placeholder}
      autoFocus={autoFocus}
    />
  );
};
